import { Controller } from "@hotwired/stimulus";

// Manages the description/notes form below the board editor.
// Listens for rig:changed events from the React board editor
// and saves changes via the rig API on blur.
export default class extends Controller {
  static targets = ["description", "notes", "trixEditor", "form"];

  connect() {
    this.rigId = null;
    this.csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    this.handleRigChanged = this.handleRigChanged.bind(this);
    document.addEventListener("rig:changed", this.handleRigChanged);

    this.preventTrixFileAccept = this.preventTrixFileAccept.bind(this);
    document.addEventListener("trix-file-accept", this.preventTrixFileAccept);
  }

  disconnect() {
    document.removeEventListener("rig:changed", this.handleRigChanged);
    document.removeEventListener("trix-file-accept", this.preventTrixFileAccept);
  }

  preventTrixFileAccept(event) {
    event.preventDefault();
  }

  handleRigChanged(event) {
    const { id, description, notes } = event.detail;
    this.rigId = id;
    this.descriptionTarget.value = description;
    this.notesTarget.value = notes || "";
    if (this.hasTrixEditorTarget) {
      this.trixEditorTarget.editor.loadHTML(notes || "");
    }
    this.formTarget.classList.remove("hidden");
  }

  save(event) {
    const field = event.target.dataset.field;
    const value = event.target.value;
    if (!this.rigId) return;

    this.saveField(field, value);
  }

  saveTrix(event) {
    const input = event.target.inputElement;
    if (!input || !this.rigId) return;

    const field = input.dataset.field;
    const value = input.value;
    this.saveField(field, value);
  }

  saveField(field, value) {
    fetch(`/api/rigs/${this.rigId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
      body: JSON.stringify({ rig: { [field]: value } }),
    });
  }
}
